import React, { useContext, useMemo } from 'react';
import { GroupBase } from 'react-select';
import { Icon } from '@src/atoms/Icon';
import { IOptionBase, ISelectMultiValueProps } from '../models';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { classnames } from '@src/utils/classnames';
import { AnyType } from '@src/models/common';

import styled from './SelectMultiValue.module.scss';
import { SelectContext } from '@src/atoms/Select/context';
import { getExtraStyles } from '@src/atoms/Select/utils';

//Todo: доработать при получении макетов
export const SelectMultiValue = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>(
  props: React.PropsWithChildren<ISelectMultiValueProps<OptionType, GroupType, IsMulti>>,
) => {
  const { isMobile } = useContext(BreakpointsContext);
  const { getValue } = React.useContext(SelectContext);
  const { classNamePrefix, value, noSelectedOptions, styles } = props.selectProps;
  const { removeProps } = props;
  const classes = classnames(styled.root, classNamePrefix);
  const extraStyles = useMemo(() => getExtraStyles(styles?.multiValue), [styles?.multiValue]);

  if (noSelectedOptions) {
    return null;
  }

  return (
    <>
      {getValue &&
        value instanceof Array &&
        value?.map((item) => (
          <span key={item.value} className={classes} data-elem="select-multi-value" style={extraStyles}>
            <div key={item.value} className={styled.rootContent}>
              {item.value}
            </div>
            {!isMobile && <Icon name="close" size={12} {...(removeProps as AnyType)} />}
          </span>
        ))}
      {!getValue && (
        <span className={classes} data-elem="select-multi-value" style={extraStyles}>
          <div className={styled.rootContent}>{props.children}</div>
          {!isMobile && <Icon name="close" size={12} {...(removeProps as AnyType)} />}
        </span>
      )}
    </>
  );
};
